import React, { useEffect, useState } from 'react'
import FileUpload from '../../components/FileUpload'
import InsertLandMaster from '../../APIs/Land/InsertLandMaster';
import ShowLand from './ShowLand/ShowLand';
import GetUnitMaster from '../../APIs/Master/UnitMaster/GetUnitMaster';
import GetStates from '../../APIs/Master/StateMaster/GetStates';
import GetCitiesByStateId from '../../APIs/Master/CityMaster/GetCitiesByStateId';
import GetUsers from '../../APIs/User/GetUsers';
import GetLandNumber from '../../APIs/Land/GetLandNumber';
import Loader from '../../components/Loader';
import SideMessage from '../../components/SideMessage';
import UpdateLandMaster from '../../APIs/Land/UpdateLandMaster';
import { isNumber } from 'highcharts';
import InputBoxNumber from '../../components/InputBoxNumber';
import InputBoxAlphaNumarics from '../../components/InputBoxAlphaNumarics';
import FileUplaod from '../../assets/js/fileUpload';
import FileUploadAPI from '../../assets/js/fileUpload';
import GetProject from '../../APIs/Project/GetProjectById';
import GetLandDetailsByProjectId from '../../APIs/Land/GetLandDetailsByProjectId';
import { useNavigate } from 'react-router-dom';

export default function AddLand(props) {
  let [rawAddress, setRawAddress] = useState([])

  let [sendForm, setSendForm] = useState(
    {
      "landNo": 0,
      "projectId": JSON.parse(window.sessionStorage.getItem("ProjectData")).projectId === undefined ? JSON.parse(window.sessionStorage.getItem("ProjectData")).projectData.projectId : JSON.parse(window.sessionStorage.getItem("ProjectData")).projectId,
      "length": 0,
      "breadth": 0,
      "landArea": "",
      "price": "",
      "unitId": "-1",
      "cityId": "-1",
      "stateId": "-1",
      "countryId": 0,
      "tahseelName": "",
      "villageName": "",
      "khasraNo": "",
      "pincode": "",
      "address": rawAddress,
      "landmark": "",
      "perUnitPrice": "",
      "noOfOwners": 1,
      "noOfOwnedBy": 0,
      "ownedByCategoryId": "1",
      "createdBy": window.userId,
      "landAreasqft": 0,
      "isAgreement": false
    }
  )
  let [isNewForm, setIsNewForm] = useState(1)
  let [loader, setLoader] = useState(0)
  let [sideToster, setSideToster] = useState({
    show: 0,
    message: '',
    type: ''
  })
  let [getland, setGetland] = useState(0)
  let [allImage, setAllImage] = useState([])
  let [unitList, setUnitList] = useState([])
  let [stateList, setStateList] = useState([])
  let [cityList, setCityList] = useState([])
  let [userList, setUserList] = useState([])
  let [unitName, setUnitName] = useState([])
  let [deletedImages, setDeletedImages] = useState([])
  let navigate = useNavigate()
  let getData = async () => {
    let respUnit = await GetUnitMaster()
    let respState = await GetStates()
    let respLandNumber = await GetLandNumber()
    if (respUnit.status === 1) {
      setUnitList(respUnit.responseValue)
    }
    if (respState.status === 1) {
      setStateList(respState.responseValue)
    }
    if (respLandNumber.status === 1) {
      setSendForm({ ...sendForm, ["landNo"]: respLandNumber.responseValue.slice(4) })

      document.getElementById("landNo").value = respLandNumber.responseValue
      document.getElementById("landNo").disabled = true

    }
  }
  let getCity = async (id) => {
    let respCity = await GetCitiesByStateId(id);
    if (respCity.status === 1) {

      setCityList(respCity.responseValue)
    }
  }
  let handleChangeold = async (e) => {
    console.log("E", e)
    let name = e.target.name;
    let value = e.target.value;

    setSendForm({ ...sendForm, [name]: value })

    if (name === "stateId") {
      getCity(value)

      var dropdown = document.getElementsByName(name)[0];
      setRawAddress([rawAddress[0], rawAddress[1], rawAddress[2], dropdown.options[dropdown.selectedIndex].text, rawAddress[4]])
      setSendForm({ ...sendForm, [name]: value, ["address"]: [rawAddress[0], rawAddress[1], rawAddress[2], dropdown.options[dropdown.selectedIndex].text, rawAddress[4]].join(",") })
    }
    else if (name === "cityId") {
      var dropdown = document.getElementsByName(name)[0];

      setRawAddress([rawAddress[0], rawAddress[1], dropdown.options[dropdown.selectedIndex].text, rawAddress[3], rawAddress[4]])
      setSendForm({ ...sendForm, [name]: value, ["address"]: [rawAddress[0], rawAddress[1], dropdown.options[dropdown.selectedIndex].text, rawAddress[3], rawAddress[4]].join(",") })

    }
    else if (name === "tahseelName") {
      setRawAddress([rawAddress[0], value, rawAddress[2], rawAddress[3], rawAddress[4]])
      setSendForm({ ...sendForm, [name]: value, ["address"]: [rawAddress[0], value, rawAddress[2], rawAddress[3], rawAddress[4]].join(",") })

    }
    else if (name === "villageName") {
      setRawAddress([value, rawAddress[1], rawAddress[2], rawAddress[3], rawAddress[4]])
      setSendForm({ ...sendForm, [name]: value, ["address"]: [value, rawAddress[1], rawAddress[2], rawAddress[3], rawAddress[4]].join(",") })

    }
    else if (name === "pincode") {
      setRawAddress([rawAddress[0], rawAddress[1], rawAddress[2], rawAddress[3], value])
      setSendForm({ ...sendForm, [name]: value, ["address"]: [rawAddress[0], rawAddress[1], rawAddress[2], rawAddress[3], value].join(",") })

    }
    else if (name === "landArea") {
      if (sendForm.price !== 0) {
        let sqftValueOnly = convertToSquareFeet(parseFloat(value), "Square Foot");
        let perunitprice = sendForm.landArea / sqftValueOnly;
        setSendForm({ ...sendForm, ["perUnitPrice"]: parseFloat(perunitprice).toFixed(2), ["price"]: sendForm.price, [name]: value })

        let sqftValue = convertToSquareFeet(parseFloat(value), sendForm.unitName === '-1' ? "Square Foot" : sendForm.unitName);
        setSendForm(sendForm => ({
          ...sendForm, [name]: value,
          "landAreasqft": sqftValue
        }))
        document.getElementById("perUnitPrice").value = parseFloat(perunitprice).toFixed(2)
      }
    }
    else if (name === "price") {
      if (sendForm.landArea !== 0) {
        let perunitprice = value / sendForm.landArea;
        setSendForm({ ...sendForm, ["perUnitPrice"]: parseFloat(perunitprice).toFixed(2), ["price"]: value })

        document.getElementById("perUnitPrice").value = parseFloat(perunitprice).toFixed(2)
      }
    }
    else if (name === "ownedByCategoryId") {
      if (value === "1") {
        // setSendForm({ ...sendForm, ["noOfOwnedBy"]: 1 })
        // document.getElementById("noOfOwnedBy").disabled = true;
        // document.getElementById("noOfOwnedBy").value = 0;
      }
      else {
        // document.getElementById("noOfOwnedBy").disabled = false;
      }
    }
    else if (name === "unitId") {
      setSendForm({ ...sendForm, "unitName": e.target.options[e.target.selectedIndex].text, [name]: value })
      let sqftValue = convertToSquareFeet(parseFloat(sendForm.landArea), e.target.options[e.target.selectedIndex].text);
      setSendForm(sendForm => ({
        ...sendForm, [name]: value,
        "landAreasqft": sqftValue
      }))
    }
    // else if (name === "unitId") {
    //   let sqftValue = convertToSquareFeet(parseFloat(value), sendForm.unitName);
    //   setSendForm(sendForm => ({
    //     ...sendForm, [name]: value,
    //     "landAreasqft": sqftValue
    //   }))
    // }
    // else if (name === "landArea") {
    //   let sqftValue = convertToSquareFeet(parseFloat(value), sendForm.unitName);
    //   setSendForm(sendForm => ({
    //     ...sendForm, [name]: value,
    //     "landAreasqft": sqftValue
    //   }))
    // }
  }
  const handleChange = (e) => {
    const { name, value } = e.target;

    setSendForm((prev) => {
      let updatedForm = { ...prev, [name]: value };

      // ---------- STATE ----------
      if (name === "stateId") {
        getCity(value);

        const dropdown = e.target;
        const stateName = dropdown.options[dropdown.selectedIndex].text;

        const updatedAddress = [
          rawAddress[0],
          rawAddress[1],
          rawAddress[2],
          stateName,
          rawAddress[4],
        ];

        setRawAddress(updatedAddress);

        updatedForm.address = updatedAddress.join(",");
      }

      // ---------- CITY ----------
      else if (name === "cityId") {
        const dropdown = e.target;
        const cityName = dropdown.options[dropdown.selectedIndex].text;

        const updatedAddress = [
          rawAddress[0],
          rawAddress[1],
          cityName,
          rawAddress[3],
          rawAddress[4],
        ];

        setRawAddress(updatedAddress);

        updatedForm.address = updatedAddress.join(",");
      }

      // ---------- TAHSHEEL ----------
      else if (name === "tahseelName") {
        const updatedAddress = [
          rawAddress[0],
          value,
          rawAddress[2],
          rawAddress[3],
          rawAddress[4],
        ];

        setRawAddress(updatedAddress);
        updatedForm.address = updatedAddress.join(",");
      }

      // ---------- VILLAGE ----------
      else if (name === "villageName") {
        const updatedAddress = [
          value,
          rawAddress[1],
          rawAddress[2],
          rawAddress[3],
          rawAddress[4],
        ];

        setRawAddress(updatedAddress);
        updatedForm.address = updatedAddress.join(",");
      }

      // ---------- PINCODE ----------
      else if (name === "pincode") {
        const updatedAddress = [
          rawAddress[0],
          rawAddress[1],
          rawAddress[2],
          rawAddress[3],
          value,
        ];

        setRawAddress(updatedAddress);
        updatedForm.address = updatedAddress.join(",");
      }

      // ---------- LAND AREA ----------
      else if (name === "landArea") {
        let landAreaValue = parseFloat(value) || 0;

        let sqftValue = convertToSquareFeet(
          landAreaValue,
          prev.unitName === "-1" ? "Square Foot" : prev.unitName
        );

        updatedForm.landAreasqft = sqftValue;

        if (prev.price && landAreaValue > 0) {
          let perUnit = prev.price / landAreaValue;
          updatedForm.perUnitPrice = parseFloat(perUnit).toFixed(2);
        }
      }

      // ---------- PRICE ----------
      else if (name === "price") {
        let priceValue = parseFloat(value) || 0;

        if (prev.landArea > 0) {
          let perUnit = priceValue / prev.landArea;
          updatedForm.perUnitPrice = parseFloat(perUnit).toFixed(2);
        }
      }

      // ---------- UNIT ----------
      else if (name === "unitId") {
        const dropdown = e.target;
        const unitName = dropdown.options[dropdown.selectedIndex].text;

        updatedForm.unitName = unitName;

        let sqftValue = convertToSquareFeet(
          parseFloat(prev.landArea) || 0,
          unitName
        );

        updatedForm.landAreasqft = sqftValue;
      }
      else if (name === "isAgreement") {
        updatedForm.isAgreement = e.target.checked;
        updatedForm.ownedByCategoryId = e.target.checked ? "4" : "1";

      }

      return updatedForm;
    });
  };
  // let handleVerification = () => {
  //   console.log("sendForm.noOfOwners",)
  //   if (sendForm.ownedByCategoryId.toString() === "2" || sendForm.ownedByCategoryId.toString() === "3") {
  //     if (sendForm.noOfOwnedBy !== 0) {
  //       if (sendForm.noOfOwners.toString().trim() !== "" && sendForm.unitId.toString() !== "-1" && sendForm.landNo !== 0 && sendForm.landArea.toString().length > 0 && sendForm.price.toString().trim() !== "" && sendForm.unitId !== 0 && sendForm.cityId.toString() !== "-1" && sendForm.stateId.toString() !== "-1" && sendForm.tahseelName.trim() !== '' && sendForm.villageName.trim() !== '' && sendForm.khasraNo.trim() !== '' && (sendForm.pincode.trim() !== '' && sendForm.pincode.trim().length === 6) && sendForm.address.trim() !== '' && sendForm.landmark.trim() !== '') {
  //         return [true, '']
  //       }
  //       else if (sendForm.landNo === 0) {
  //         return [false, 'Please Enter Land Number']

  //       }

  //       else if (sendForm.noOfOwners.toString().trim() === "") {
  //         return [false, 'Please Enter Number of Land Owners']

  //       }

  //       else if (sendForm.landArea.toString().trim() === '') {
  //         return [false, 'Please Enter Landarea']
  //       }

  //       else if (sendForm.unitId.toString() === "-1") {
  //         return [false, 'Please Select Unit']

  //       }
  //       else if (sendForm.stateId.toString() === "-1") {
  //         return [false, 'Please Select State']

  //       }
  //       else if (sendForm.cityId.toString() === "-1") {
  //         return [false, 'Please Select City']

  //       }

  //       // else if (sendForm.landNo === 0) {
  //       //   return [false, 'Please Enter Land Number']

  //       // }
  //       else if (sendForm.tahseelName.trim() === '') {
  //         return [false, 'Please Enter Tahseel Name']

  //       }
  //       else if (sendForm.villageName.trim() === '') {
  //         return [false, 'Please Enter Village Name']

  //       }
  //       else if (sendForm.khasraNo.trim() === '') {
  //         return [false, 'Please Enter KhasraNo']

  //       }
  //       else if (sendForm.pincode.trim() === '' || sendForm.pincode.trim().length < 6) {
  //         if (sendForm.pincode.trim() === '') {
  //           return [false, 'Please Enter Pin Code']
  //         }
  //         else {
  //           return [false, 'Please Enter 6 Digits Pin Code']

  //         }

  //       }

  //       else if (sendForm.landmark.trim() === '') {
  //         return [false, 'Please Enter Landmark']

  //       }
  //       else if (sendForm.price === 0 || sendForm.price === "") {
  //         return [false, 'Please Enter Price']

  //       }
  //       else if (sendForm.address.trim() === '') {
  //         return [false, 'Please Enter Address']

  //       }

  //     }
  //     else {
  //       return [false, 'Please Enter Number Of Investor']

  //     }
  //   }
  //   else {
  //     if (sendForm.ownedByCategoryId.toString() === "1") {
  //       if (sendForm.noOfOwners.toString().trim() !== "" && sendForm.unitId.toString() !== "-1" && sendForm.landNo !== 0 && Number(sendForm.landArea) > 0 && sendForm.price.toString().trim() !== "" && sendForm.unitId !== 0 && sendForm.cityId.toString() !== "-1" && sendForm.stateId.toString() !== "-1" && sendForm.tahseelName.trim() !== '' && sendForm.villageName.trim() !== '' && sendForm.khasraNo.trim() !== '' && (sendForm.pincode.trim() !== '' && sendForm.pincode.trim().length === 6) && sendForm.address.trim() !== '' && sendForm.landmark.trim() !== '') {
  //         return [true, '']
  //       }
  //       else if (sendForm.landNo === 0) {
  //         return [false, 'Please Enter Land Number']

  //       }
  //       else if (sendForm.noOfOwners.toString().trim() === "") {
  //         return [false, 'Please Enter Number of Land Owners']

  //       }
  //       else if (sendForm.landArea.toString().trim() === '') {
  //         return [false, 'Please Enter Landarea']
  //       }

  //       else if (sendForm.unitId.toString() === "-1") {
  //         return [false, 'Please Select Unit']

  //       }
  //       else if (sendForm.stateId.toString() === "-1") {
  //         return [false, 'Please Select State']

  //       }
  //       else if (sendForm.cityId.toString() === "-1") {
  //         return [false, 'Please Select City']

  //       }
  //       // else if (sendForm.landNo === 0) {
  //       //   return [false, 'Please Enter Land Number']

  //       // }
  //       else if (sendForm.tahseelName.trim() === '') {
  //         return [false, 'Please Enter Tahseel Name']

  //       }
  //       else if (sendForm.villageName.trim() === '') {
  //         return [false, 'Please Enter Village Name']

  //       }
  //       else if (sendForm.khasraNo.trim() === '') {
  //         return [false, 'Please Enter KhasraNo']

  //       }
  //       else if (sendForm.pincode.trim() === '' || sendForm.pincode.trim().length < 6) {
  //         if (sendForm.pincode.trim() === '') {
  //           return [false, 'Please Enter Pin Code']
  //         }
  //         else {
  //           return [false, 'Please Enter 6 Digits Pin Code']

  //         }

  //       }

  //       else if (sendForm.landmark.trim() === '') {
  //         return [false, 'Please Enter Landmark']

  //       }
  //       else if (sendForm.price === 0 || sendForm.price === "") {
  //         return [false, 'Please Enter Price']

  //       }
  //       else if (sendForm.address.trim() === '') {
  //         return [false, 'Please Enter Address']

  //       }

  //     }
  //     else {
  //       return [false, 'Somthing went wrong']

  //     }


  //   }

  //   // else if (sendForm.percentage.trim() === '') {
  //   //   return [false, 'Please Enter percentage']

  //   // }
  // }
  const handleVerification = () => {
    const {
      landNo,
      noOfOwners,
      noOfOwnedBy,
      ownedByCategoryId,
      landArea,
      price,
      unitId,
      cityId,
      stateId,
      tahseelName,
      villageName,
      khasraNo,
      pincode,
      address,
      landmark
    } = sendForm;

    // ----------- BASIC VALIDATIONS -----------

    if (!landNo || Number(landNo) <= 0) {
      return [false, "Please Enter Land Number"];
    }

    if (!noOfOwners || Number(noOfOwners) <= 0) {
      return [false, "Please Enter Number of Land Owners"];
    }

    if (!landArea || Number(landArea) <= 0) {
      return [false, "Please Enter Valid Land Area"];
    }

    if (!price || Number(price) <= 0) {
      return [false, "Please Enter Valid Price"];
    }

    if (unitId === "-1" || unitId === 0) {
      return [false, "Please Select Unit"];
    }

    if (stateId === "-1") {
      return [false, "Please Select State"];
    }

    if (cityId === "-1") {
      return [false, "Please Select City"];
    }

    if (!tahseelName?.trim()) {
      return [false, "Please Enter Tahseel Name"];
    }

    // if (!villageName?.trim()) {
    //   return [false, "Please Enter Village Name"];
    // }

    if (!khasraNo || khasraNo === 0 || khasraNo === "0") {
      return [false, "Please Enter Valid Khasra Number"];
    }

    if (!pincode || pincode.toString().length !== 6) {
      return [false, "Please Enter Valid 6 Digit Pin Code"];
    }

    if (!landmark?.trim()) {
      return [false, "Please Enter Landmark"];
    }

    if (!address?.trim()) {
      return [false, "Please Enter Address"];
    }

    // ----------- INVESTOR VALIDATION -----------

    if (
      ownedByCategoryId.toString() === "2" ||
      ownedByCategoryId.toString() === "3"
    ) {
      if (!noOfOwnedBy || Number(noOfOwnedBy) <= 0) {
        return [false, "Please Enter Number Of Investors"];
      }
    }

    // ----------- ALL GOOD -----------

    return [true, ""];
  };
  let handleSave = async () => {
    let validate = handleVerification()
    if (validate[0]) {
      setLoader(1)
      let formData = new FormData()
      Object.keys(sendForm).map((name) => {
        formData.append(name, sendForm[name]);
      })
      allImage.map((val, ind) => {
        formData.append("landFiles", val);
      })
      let response = await FileUploadAPI(formData, window.RealestateService + `/api/Land/InsertLandMaster`)
      let resp = response.data
      console.log("response", resp)
      // let resp = await InsertLandMaster(formData)
      if (resp.status === 1) {
        setLoader(0)
        let sessiondata = JSON.parse(window.sessionStorage.getItem("ProjectData"))
        console.log("form", sessiondata)

        window.sessionStorage.setItem("ProjectData", JSON.stringify({ ...sessiondata, "landData": resp.responseValue }))
        setGetland(getData + 1)
        if (sendForm["noOfOwnedBy"] !== 0) {
          props.handleActiveTab(1)
        }
        else {
          if (parseInt(sendForm.ownedByCategoryId) === 4) {
            props.handleActiveTab(4)
          }
          else {
            props.handleActiveTab(2)
          }

        }
      }
      else {
        setSideToster({
          show: 1,
          message: resp.responseValue,
          type: 'Alert'
        })
        setLoader(0)

      }
    }
    else {
      setSideToster({
        show: 1,
        message: validate[1],
        type: 'Alert'
      })
    }
  }
  let handleUpdate = async () => {
    let validate = handleVerification()
    console.log("vali", validate)
    if (validate[0]) {
      setLoader(1)
      let formData = new FormData()
      console.log("sendForm", sendForm)
      Object.keys(sendForm).map((name) => {
        // if (name === "landNo") {
        //   let value = sendForm[name];

        //   formData.append(
        //     name,
        //     typeof value === "string" ? value.slice(4) : value
        //   );
        // }
        if (name === "landNo") {
          let value = sendForm[name];

          // If value has prefix like LAND123 → remove prefix
          if (typeof value === "string" && value.length > 4 && isNaN(value)) {
            value = value.slice(4);
          }

          formData.append(name, value || 0);
        }
        else {

          formData.append(name, sendForm[name]);
        }
      })
      if (allImage.length !== 0) {
        allImage.map((val, ind) => {
          formData.append("landFiles", val);
        })
      }
      else {
        formData.append("landFiles", []);

      }
      if (deletedImages.length !== 0) {
        deletedImages.map((val, ind) => {
          formData.append("landImageIdList", val);
        })
      }

      // console.log("delete Id", deletedImages)
      else {
        formData.append("landImageIdList", [0]);

      }


      // let resp = await UpdateLandMaster(formData)
      let response = await FileUploadAPI(formData, window.RealestateService + `/api/Land/UpdateLandMaster`)
      let resp = response.data
      if (resp.status === 1) {
        setLoader(0)
        let sessiondata = JSON.parse(window.sessionStorage.getItem("ProjectData"))
        console.log("sendForm", sendForm)
        window.sessionStorage.setItem("ProjectData", JSON.stringify({ ...sessiondata, "landData": resp.responseValue }))
        setGetland(getData + 1)
        if (parseInt(sendForm.ownedByCategoryId) !== 1 && parseInt(sendForm.ownedByCategoryId) !== 4) {
          props.handleActiveTab(1)
        }
        else {
          if (parseInt(sendForm.ownedByCategoryId) === 4) {
            props.handleActiveTab(4)
          }
          else {
            props.handleActiveTab(2)
          }

        }
      }
      else {
        setSideToster({
          show: 1,
          message: resp.responseValue,
          type: 'Alert'
        })
        setLoader(0)

      }
    }
    else {
      setSideToster({
        show: 1,
        message: validate[1],
        type: 'Alert'
      })
    }
  }
  // let handleEdit = (data) => {
  //   getCity(data.stateId)
  //   console.log("data0", data)
  //   setSendForm(data)
  // }
  function convertToSquareFeet(value, unit = "Square Foot") {
    const conversionRates = {
      "Acre": 43560,
      "Bigha": 27000,
      "Hectare": 107639.104,
      "Guntha": 1089,
      "Kanal": 544.5,
      "Square Meter": 10.7639,
      "Square Foot": 1,
      "Marla": 272.25,
      "Cent": 435.6,
      "Rood": 3630,
      "Square Yard": 9,
      "Truck": 0  // This needs to be defined with a size
    };

    if (conversionRates[unit]) {
      return isNaN(value * conversionRates[unit]) ? 0 : parseFloat(value * conversionRates[unit]).toFixed(2);
    } else {
      console.log("Invalid unit");
      return 0;
    }
  }

  let handleGotDashboard = async () => {
    let projectId = JSON.parse(window.sessionStorage.getItem("ProjectData")).projectId
    let response = await GetProject(projectId)
    let resp = await GetLandDetailsByProjectId(projectId);
    if (response.status === 1) {
      let data = JSON.parse(window.sessionStorage.getItem("ProjectData"))
      window.sessionStorage.setItem("ProjectData", JSON.stringify({ allLandData: resp.responseValue, projectData: response.responseValue[0], projectId: projectId }))
      // setProjectData(response.responseValue[0])
      navigate("/projectdashboard/")
    }

  }

  useEffect(() => {
    const fetchData = async () => {
      setLoader(true); // Set loader while fetching data

      try {
        let respUnit = await GetUnitMaster();
        let respState = await GetStates();
        let respLandNumber = await GetLandNumber();

        // Process Unit Data
        if (respUnit.status === 1) {
          setUnitList(respUnit.responseValue);
        }

        // Process State Data
        if (respState.status === 1) {
          setStateList(respState.responseValue);
        }

        // Process Land Number Data
        if (respLandNumber.status === 1) {
          const landNoValue = respLandNumber.responseValue;
          setSendForm(prevForm => ({ ...prevForm, landNo: landNoValue.slice(4) }));

          const landNoInput = document.getElementById("landNo");
          if (landNoInput) {
            landNoInput.value = landNoValue;
            landNoInput.disabled = true;
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoader(false); // Remove loader once data is processed
      }
    };

    const initializeForm = () => {
      const projectData = JSON.parse(window.sessionStorage.getItem("ProjectData"));
      if (projectData?.landData) {
        console.log("data", projectData.landData);
        setLoader(true);

        const data = projectData.landData;
        getCity(data.stateId);
        setAllImage(data.imageDetails ?? []);
        setIsNewForm(0);

        setTimeout(() => {
          const temp = { ...data };
          temp.landAreasqft = convertToSquareFeet(data.landArea, data.unitName);
          temp.perUnitPrice = data.price / temp.landAreasqft;

          const perUnitPriceInput = document.getElementById("perUnitPrice");
          if (perUnitPriceInput) {
            perUnitPriceInput.value = parseFloat(temp.perUnitPrice).toFixed(2);
          }

          setSendForm(temp);
          setLoader(false);
        }, 1000);
      }
    };

    // Call functions on component mount
    fetchData();
    initializeForm();

    // Ensure page scrolling is enabled
    document.body.style.overflowY = "scroll";
  }, []); // Empty dependency array ensures this runs only once

  return (

    <>
      {/* <div className='display-container'> */}

      {/* <ShowLand handleEdit={handleEdit} change={getland} /> */}
      {/* </div> */}
      <div className='container-fluid landformconatiner p-4' id="conatinerId">
        <div className='d-flex flex-row align-items-center gap-2' >
          <label className='form-label'>Is Agreement</label>
          <input type='checkbox' name='isAgreement' id="isAgreement" defaultChecked={sendForm.isAgreement} onChange={handleChange} className='mb-1' />
        </div>
        <div className='wrapform'>

          <div className='d-flex flex-column gap-1 d-none' >
            <label className='form-label'>Land Number</label>
            <input type='text' name='landNo' id="landNo" value={sendForm.landNo} onChange={handleChange} placeholder='Enter Land Number' className='form-input-box' />
          </div>
          {
            !sendForm?.isAgreement ?
              <div className={`d-flex flex-column gap-1`}>
                <label className='form-label'>Owned Category</label>
                <select className='form-input-box form-select pe-5' name='ownedByCategoryId' value={sendForm.ownedByCategoryId} onChange={handleChange} disabled={sendForm.isAgreement}>
                  <option value="1">Vifa</option>
                  <option value="2">Investor</option>
                  <option value="3">Vifa and Investor</option>
                </select>
              </div>
              :
              <></>
          }
          <div  >
            {/* hiiiiiiiiiiiiiiii */}

            {
              (parseInt(sendForm.ownedByCategoryId) !== 1 && parseInt(sendForm.ownedByCategoryId) !== 0 && parseInt(sendForm.ownedByCategoryId) !== 4) ? (
                <div className='d-flex flex-column gap-1' >
                  <label className='form-label'>Number of Investor</label>
                  {/* <input type='number' min={1} name='noOfOwnedBy' onChange={handleChange} value={sendForm.noOfOwnedBy} id="noOfOwnedBy" placeholder='Enter No. Of Owned' className='form-input-box' /> */}
                  {
                    isNewForm !== 1 ? (

                      <InputBoxNumber name="noOfOwnedBy" value={sendForm.noOfOwnedBy} placeholder='Enter No. Of Owned' setSendForm={setSendForm} range={10} />
                    ) : (
                      <InputBoxNumber name="noOfOwnedBy" value={sendForm.noOfOwnedBy} placeholder='Enter No. Of Owned' setSendForm={setSendForm} range={10} />

                    )}

                </div>) : ""
            }

            <div className='d-flex flex-column gap-1'>
              <label className='form-label'>Number of Land Owners</label>


              {
                isNewForm !== 1 ? (

                  <InputBoxNumber name="noOfOwners" value={sendForm.noOfOwners} placeholder='Enter No. Of Owners' id="noOfOwners" setSendForm={setSendForm} range={10} isIntegerOnly={true} />)
                  :
                  (<InputBoxNumber name="noOfOwners" value={sendForm.noOfOwners} placeholder='Enter No. Of Owners' id="noOfOwners" setSendForm={setSendForm} range={10} isIntegerOnly={true} />

                  )}


            </div>
          </div>


          <div className='d-flex flex-column gap-1'>
            <label className="form-label">Land Area</label>
            <InputBoxNumber
              name="landArea"
              value={sendForm.landArea}
              placeholder="Enter Land Area"
              setSendForm={handleChange}
              range={10}
              isFun={true}
            />
          </div>

          <div className='d-flex flex-column gap-1'>
            <label className="form-label">Land Area (sqft)</label>
            <InputBoxNumber
              name="landAreasqft"
              value={sendForm.landAreasqft}
              placeholder="Enter Land Area"
              range={10}
            />
          </div>

          <div className='d-flex flex-column gap-1'>
            <label className="form-label">Choose Unit</label>
            <select
              className="form-input-box form-select pe-5"
              name="unitId"
              value={sendForm.unitId}
              onChange={handleChange}
            >
              <option value="-1">--Select Unit--</option>
              {unitList &&
                unitList.map((val, ind) => (
                  <option key={ind} value={val.id}>
                    {val.name}
                  </option>
                ))}
            </select>
          </div>


          <div className='d-flex flex-column gap-1'>


            <label className='form-label'>Select State</label>
            <select className='form-input-box form-select pe-5' name='stateId' value={sendForm.stateId} onChange={handleChange}>
              <option value="-1">--Select State--</option>
              {
                stateList && stateList.map((val, ind) => {
                  return (
                    <option value={val.id}>
                      {val.stateName}
                    </option>
                  )
                })
              }
            </select>
          </div>
          {/* <div className='row pb-4'>
          <div className='col col-md-4 pb-2 pb-md-0'>
            <div className='d-flex flex-column gap-1'>
              <label className='form-label'>Land Area</label>
              <input type='number' name='landArea' onChange={handleChange} value={sendForm.landArea} placeholder='Enter Land Area' className='form-input-box' />
            </div>
          </div>
          <div className='col col-md-4 pb-2 pb-md-0'>
            <div className='d-flex flex-column gap-1'>
              <label className='form-label'>Choose Unit</label>
              <select className='form-input-box pe-5' name='unitId' value={sendForm.unitId} onChange={handleChange}>
                <option value="-1">--select Unit--</option>
                {
                  unitList && unitList.map((val, ind) => {
                    return (
                      <option value={val.id}>
                        {val.name}
                      </option>
                    )
                  })
                }
              </select>
            </div>
          </div>
          <div className='col col-md-4 pb-2 pb-md-0'>
            <div className='d-flex flex-column gap-1'>
              <label className='form-label'>Select State</label>
              <select className='form-input-box pe-5' name='stateId' value={sendForm.stateId} onChange={handleChange}>
                <option value="-1">--select State--</option>
                {
                  stateList && stateList.map((val, ind) => {
                    return (
                      <option value={val.id}>
                        {val.stateName}
                      </option>
                    )
                  })
                }
              </select>
            </div>
          </div>
        </div> */}

          <div className='d-flex flex-column gap-1'>
            <label className='form-label'>Select City</label>
            <select className='form-input-box form-select pe-5' name='cityId' value={sendForm.cityId} onChange={handleChange}>
              <option value="-1">--Select City--</option>
              {
                cityList && cityList.map((val, ind) => {
                  return (
                    <option value={val.id}>
                      {val.cityName}
                    </option>
                  )
                })
              }
            </select>
          </div>
          <div className='d-flex flex-column gap-1'>
            <label className='form-label'>Tahsheel</label>
            <input type='text' name='tahseelName' onChange={handleChange} value={sendForm.tahseelName} placeholder='Enter Tahseel Name' className='form-input-box' />

            {/* <select className='form-input-box pe-5' name='price' onChange={handleChange}>
                <option value="-1">--select Tahsheel--</option>

              </select> */}
          </div>
          <div className='d-flex flex-column gap-1'>
            <label className='form-label'>Village</label>
            <input type='text' name='villageName' onChange={handleChange} value={sendForm.villageName} placeholder='Enter Village Name' className='form-input-box' />


            {/* <select className='form-input-box pe-5' name='price' onChange={handleChange}>
                <option value="-1">--select Village--</option>

              </select> */}
          </div>
          {/* <div className='row pb-4'>


          <div className='col col-md-4 pb-2 pb-md-0'>
            <div className='d-flex flex-column gap-1'>
              <label className='form-label'>Select City</label>
              <select className='form-input-box pe-5' name='cityId' value={sendForm.cityId} onChange={handleChange}>
                <option value="-1">--select City--</option>
                {
                  cityList && cityList.map((val, ind) => {
                    return (
                      <option value={val.id}>
                        {val.cityName}
                      </option>
                    )
                  })
                }
              </select>
            </div>
          </div>
          <div className='col col-md-4 pb-2 pb-md-0'>
            <div className='d-flex flex-column gap-1'>
              <label className='form-label'>Tahsheel</label>
              <input type='text' name='tahseelName' onChange={handleChange} value={sendForm.tahseelName} placeholder='Enter Tahseel Name' className='form-input-box' />

              
            </div>
          </div>
          <div className='col col-md-4 pb-2 pb-md-0'>
            <div className='d-flex flex-column gap-1'>
              <label className='form-label'>Village</label>
              <input type='text' name='villageName' onChange={handleChange} value={sendForm.villageName} placeholder='Enter Tahseel Name' className='form-input-box' />

              
            </div>
          </div>
        </div> */}

          <div className='d-flex flex-column gap-1'>
            <label className='form-label'>Khasra No</label>
            {/* <input type='string' name='khasraNo' onChange={handleChange} value={sendForm.khasraNo} placeholder='Enter Khasra No' className='form-input-box' /> */}
            <InputBoxAlphaNumarics name="khasraNo" value={sendForm.khasraNo} placeholder='Enter Khasra No.' setSendForm={setSendForm} range={15} />

          </div>
          <div className='d-flex flex-column gap-1'>
            <label className='form-label'>Pin Code</label>
            {/* <input type='number' name='pincode' min={0} onChange={handleChange} value={sendForm.pincode} placeholder='Enter Pin Code' className='form-input-box' /> */}
            <InputBoxNumber name="pincode" value={sendForm.pincode} placeholder='Enter Pin Code' errorMessage={"Please Enter min 6 digits"} setSendForm={setSendForm} range={6} />

          </div>
          <div className='d-flex flex-column gap-1'>
            <label className='form-label'>Land Mark</label>
            <input type='text' name='landmark' onChange={handleChange} value={sendForm.landmark} placeholder='Enter Land Mark' className='form-input-box' />
          </div>
          {/* <div className='row pb-4'>


          <div className='col col-md-4 pb-2 pb-md-0'>
            <div className='d-flex flex-column gap-1'>
              <label className='form-label'>Khasra No</label>
              <input type='number' name='khasraNo' onChange={handleChange} value={sendForm.khasraNo} placeholder='Enter Khasra No' className='form-input-box' />
            </div>
          </div>
          <div className='col col-md-4 pb-2 pb-md-0'>
            <div className='d-flex flex-column gap-1'>
              <label className='form-label'>Pin Code</label>
              <input type='number' name='pincode' onChange={handleChange} value={sendForm.pincode} placeholder='Enter Pin Code' className='form-input-box' />
            </div>
          </div>
          <div className='col col-md-4 pb-2 pb-md-0'>
            <div className='d-flex flex-column gap-1'>
              <label className='form-label'>Land Mark</label>
              <input type='text' name='landmark' onChange={handleChange} value={sendForm.landmark} placeholder='Enter Land Mark' className='form-input-box' />
            </div>
          </div>

        </div> */}

          <div className='d-flex flex-column gap-1'>
            <label className='form-label'>Total Land Price (&#8377;)</label>
            {/* <input type='number' name='price' min={0} onChange={handleChange} value={sendForm.price} placeholder='Enter Total price' className='form-input-box' /> */}
            <InputBoxNumber name="price" value={sendForm.price} placeholder='Enter Total Price' setSendForm={setSendForm} range={10} />

          </div>
          <div className='d-flex flex-column gap-1'>
            <label className='form-label'>Per Unit Price (sqft)</label>
            <input type='number' name='perUnitPrice' min={0} id="perUnitPrice" value={parseFloat(sendForm.price / sendForm.landAreasqft).toFixed(2)} onChange={handleChange} placeholder='Enter Per Unit Price' className='form-input-box' disabled />
          </div>

          {/* <div className='row pb-4'>


          <div className='col col-md-4 pb-2 pb-md-0'>
            <div className='d-flex flex-column gap-1'>
              <label className='form-label'>Total Land price</label>
              <input type='number' name='price' onChange={handleChange} value={sendForm.price} placeholder='Enter Total price' className='form-input-box' />
            </div>
          </div>
          <div className='col col-md-4 pb-2 pb-md-0'>
            <div className='d-flex flex-column gap-1'>
              <label className='form-label'>Per Unit price</label>
              <input type='number' name='perUnitPrice' id="perUnitPrice" value={sendForm.perUnitPrice} onChange={handleChange} placeholder='Enter Per Unit price' className='form-input-box' disabled />
            </div>
          </div>
          <div className='col col-md-4 pb-2 pb-md-0'>
            <div className='d-flex flex-column gap-1'>
              <label className='form-label'>address</label>
              <textarea className='form-input-box' name='address' value={sendForm.address} placeholder='Enter address' onChange={handleChange}></textarea>

            </div>
          </div>
        </div> */}

          {/* <div className='row pb-4'>

        </div> */}
        </div>
        <div className='row mt-3'>
          <div className='d-flex flex-column gap-1'>
            <label className='form-label'>Address</label>
            <textarea className='form-input-box pt-2' name='address' value={sendForm.address} disabled></textarea>
            {/* <input type='text' className='form-input-box' /> */}
          </div>
        </div>
        <FileUpload setDeletedImages={setDeletedImages} deletedImages={deletedImages} setAllImage={setAllImage} allImage={allImage} name="Property Pictures" />
      </div>
      <div className='d-flex flex-row justify-content-md-end'>
        {
          isNewForm === 1 ?
            <button className='btn export-save-btn' onClick={handleSave}>Save Land & Next</button>

            :
            <div className='d-flex flex-row gap-2'>
              <button className='btn export-save-btn' onClick={handleUpdate}>Update Land & Next</button>
              <button className='btn export-save-btn' onClick={handleGotDashboard}>Cancel</button>
            </div>
        }
      </div>

      <Loader show={loader} />

      {
        sideToster.show === 1 ?
          <SideMessage close={setSideToster} show={sideToster.show} type={sideToster.type} message={sideToster.message} />
          : ""
      }
    </>


  )
}
